@import 'common/component';
@import 'forms/reset/input';
@import '~flatpickr/dist/flatpickr.css';

:host {
  display: block;
}

@import 'forms/custom/o2-input-group';
@import 'forms/custom/o2-label';
@import 'forms/custom/o2-input';

input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-calendar-picker-indicator,
input[type='time']::-webkit-calendar-picker-indicator,
input[type='datetime-local']::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.o2-input {
  &[disabled] .button {
    display: none;
  }
}

.flatpickr-wrapper {
  display: block;
}

.flatpickr-calendar {
  width: 31.2rem;
  padding: $spacing-4;
  border-radius: $radius-xs;

  &::before,
  &::after {
    content: none;
  }
  &.inline {
    box-shadow: none;
    border: 1px solid var(--o2-input-border-color, #{$gray-light});
  }
}

.flatpickr-innerContainer,
.flatpickr-rContainer {
  display: block;
}

.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  top: initial;
  height: auto;
  padding: initial;
  color: initial;
  fill: initial;
  padding: 0.4rem;

  o2-icon {
    width: 2.4rem;
  }
}

.flatpickr-months {
  padding-bottom: $spacing-4;
  border-bottom: 1px solid $gray-ultra-light;
}

.flatpickr-months .flatpickr-prev-month {
  margin-left: $spacing-4;
}

.flatpickr-months .flatpickr-next-month {
  margin-right: $spacing-4;
}

.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  width: auto;
  height: auto;
}

.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: $black;
}

.flatpickr-current-month .flatpickr-monthDropdown-months:hover,
.numInputWrapper:hover {
  background: mix($black, $white, $opacity-hover * 1%);
}

.flatpickr-current-month {
  display: flex;
  justify-content: center;
  height: 3.2rem;
  padding: 0;
}

.flatpickr-current-month .numInputWrapper {
  display: flex;
  width: auto;
}

.flatpickr-current-month,
.flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-current-month input.cur-year {
  font-size: 1.6rem;
  font-style: normal;
  @include font-weight(600);
  line-height: 1.3;
  color: $black;
  padding: 0;
  margin: 0;
}

.flatpickr-current-month .flatpickr-monthDropdown-months {
  padding-left: 0.8rem;
  padding-right: 0.8rem;
}
.flatpickr-current-month input.cur-year {
  padding: 0.8rem;
}

.numInputWrapper span.arrowUp,
.numInputWrapper span.arrowDown {
  display: none;
}

.flatpickr-weekdays {
  padding: $spacing-4 0;
  height: auto;
}

span.flatpickr-weekday,
.flatpickr-day {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 4rem;
  height: 4rem;
  color: $gray-medium;
  font-size: 1.6rem;
  line-height: 1.3;
}

span.flatpickr-weekday {
  color: $gray-medium;
  @include font-weight(400);
}

.flatpickr-day {
  border-radius: $radius-xs;
  padding: 1rem 0 0.9rem 0;
  color: $black;

  &:hover {
    background: $blue-action !important;
    border-color: $blue-action !important;
    color: white;
  }

  &.selected {
    background: $blue-action;
    border-color: $blue-action;

    &:hover {
      background: $blue-action;
      border-color: $blue-action;
    }
  }

  &.today {
    border-color: $blue-action;

    &:hover {
      background: $blue-action;
      border-color: $blue-action;
      color: white;
    }
  }

  &.inRange {
    background: $dark-opacity-005;
    border: 0;
    box-shadow: none;
  }
}

// range start
.rangeMode .flatpickr-day {
  margin: 0;
}

.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
  background: $blue-action;
  border-color: $blue-action;
  border-radius: $radius-xs;
}

.flatpickr-day.selected.startRange,
.flatpickr-day.startRange.startRange,
.flatpickr-day.endRange.startRange {
  border-radius: $radius-xs;
}

.flatpickr-day.selected.endRange,
.flatpickr-day.startRange.endRange,
.flatpickr-day.endRange.endRange {
  border-radius: $radius-xs;
}

// range end

.dayContainer {
  justify-content: initial;
}

.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.prevMonthDay,
.flatpickr-day.nextMonthDay,
.flatpickr-day.notAllowed,
.flatpickr-day.notAllowed.prevMonthDay,
.flatpickr-day.notAllowed.nextMonthDay {
  color: $gray-medium;
}

.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
  border-top: 0;
}

.flatpickr-time input.flatpickr-hour:hover,
.flatpickr-time input.flatpickr-minute:hover {
  background: mix($black, $white, $opacity-hover * 1%);
}
